import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LoggingService } from './log.service';
import { throwError } from 'rxjs';
import { SettingsService } from '../settings/settings.service';
import { APPCONFIG } from '../../app.config';
import { AnalysisService } from './analysis.service';
import { S1UIService } from '@app/s1/services/s1-ui.service';



@Injectable()
export class AppService {

  public paging = true;
  public itemsPerPage = environment.rows; // server pagination
  public page: number = 1;
  public numPages = 1;
  public totalItems = 1;

  constructor(
    private http: HttpClient,
    private logger: LoggingService,
    private router: Router,
    private settings: SettingsService,
    private analysisService: AnalysisService,
    private ui: S1UIService
  ) {}

    // modify of an element
    deleteUser(userID): any {
      let path = '/admin/user/'
      let endpoint = environment.restBaseUrl + path + userID;
      return this.http
        .delete<any[]>(endpoint, this.getRequestOptionArgs())
        .pipe(map(
        (response: HttpResponse<any>) => {
          const outcome = response['outcome'];
          const dataResponse = response['data'];
          if (outcome.success === true) {
            this.logger.log("Service:", "SUCCESS", 200);
            return response;
          } else {
            this.logger.log("Service:", "FAILURE", 200);
            outcome.message = this.settings.manageErrorMsg(outcome);
            return outcome;
          }
        }
      ), catchError((errorResponse: HttpErrorResponse) => {
          this.logger.log("Error Response:", errorResponse, 200);
          let res: any = errorResponse.error;
          if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
            this.settings.sessionExpired();
          }
          return throwError(() => errorResponse.error);
        }
      ));
    }


  // Rest Items List Service
  getList(filters) {
    let path = `/admin/user/list/${APPCONFIG.currentLanguage}`
    let url = environment.restBaseUrl + path;
    this.logger.log("Chiamata URL lista:" + url, "", 200);
    return this.http
        .post<any[]>(url, filters, this.getRequestOptionArgs())
        .pipe(map(
            (response: HttpResponse<any>) => {
                const outcome = response['outcome'];
                const data = response['results'];
                this.totalItems = response['total'];

                if (outcome.success === true) {
                    this.logger.log("Service:", "SUCCESS", 200);
                    return response;
                } else {
                    this.logger.log("Service:", "FAILURE", 200);
                    outcome.message = this.settings.manageErrorMsg(outcome);
                    return outcome;
                }
            }
        ), catchError((errorResponse: HttpErrorResponse) => {
            const res: any = errorResponse.error;
            if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
                this.settings.sessionExpired();
            }
            return throwError(() => errorResponse.error);
        }
        ));
}

  // Rest Items Service: Read one element (detail)
  getElement(path) {
    path = environment.restBaseUrl + path;
    return this.http
      .get<any[]>(path, this.getRequestOptionArgs())
      .pipe(map(
      (response: HttpResponse<any>) => {
        const outcome = response['outcome'];
        if (outcome.success === true) {
          this.logger.log("Service:", "SUCCESS", 200);
          return response;
        } else {
          this.logger.log("Service:", "FAILURE", 200);
          outcome.message = this.settings.manageErrorMsg(outcome);
          return outcome;
        }
      }
    ), catchError((errorResponse: HttpErrorResponse) => {
        let res: any = errorResponse.error;
        if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
          this.settings.sessionExpired();
        }
        return throwError(() => errorResponse.error);
      }
    ));
  }

  // Rest Items Service: Read all REST Items
  getAll(path) {
    path = environment.restBaseUrl + path;
    return this.http
      .get<any[]>(path, this.getRequestOptionArgs())
      .pipe(map(
      (response: HttpResponse<any>) => {
        const outcome = response['outcome'];
        const dataResponse = response['data'];
        this.totalItems = dataResponse['total'];
        if (outcome.success === true) {
          this.logger.log("Service:", "SUCCESS", 200);
          return dataResponse;
        } else {
          this.logger.log("Service:", "FAILURE", 200);
          outcome.message = this.settings.manageErrorMsg(outcome);
          return outcome;
        }
      }
    ), catchError((errorResponse: HttpErrorResponse) => {
        let res: any = errorResponse.error;
        if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
          this.settings.sessionExpired();
        }
        return throwError(() => errorResponse.error);
      }
    ));
  }

  // get element list by data passed
  getAllFromData(path, requestData): any {
    path = environment.restBaseUrl + path;
    return this.http
      .post<any[]>(path, requestData, this.getRequestOptionArgs())
      .pipe(map(
      (response: HttpResponse<any>) => {
        const outcome = response['outcome'];
        const dataResponse = response['data'];
        if (outcome.success === true) {
          this.logger.log("Service:", "SUCCESS", 200);
          return dataResponse;
        } else {
          this.logger.log("Service:", "FAILURE", 200);
          outcome.message = this.settings.manageErrorMsg(outcome);
          return outcome;
        }
      }
    ), catchError((errorResponse: HttpErrorResponse) => {
        this.logger.log("Error Response:", errorResponse, 200);
        let res: any = errorResponse.error;
        if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
          this.settings.sessionExpired();
        }
        return throwError(() => errorResponse.error);
      }
    ));
  }

  // creation of new element
  newElement(path, elementRequest): any {
    path = environment.restBaseUrl + path;
    return this.http
      .post<any[]>(path, elementRequest, this.getRequestOptionArgs())
      .pipe(map(
      (response: HttpResponse<any>) => {
        const outcome = response['outcome'];
        const dataResponse = response['data'];
        if (outcome.success === true) {
          this.logger.log("Service:", "SUCCESS", 200);
          return response;
        } else {
          this.logger.log("Service:", "FAILURE", 200);
          outcome.message = this.settings.manageErrorMsg(outcome);
          return response;
        }
      }
    ), catchError((errorResponse: HttpErrorResponse) => {
        this.logger.log("Error Response:", errorResponse, 200);
        let res: any = errorResponse.error;
        if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
          this.settings.sessionExpired();
        }
        return throwError(() => errorResponse.error);
      }
    ));
  }

  // modify of an element
  editElement(path, elementRequest): any {
    debugger;
    path = environment.restBaseUrl + path;
    return this.http
      .put<any[]>(path, elementRequest, this.getRequestOptionArgs())
      .pipe(map(
      (response: HttpResponse<any>) => {
        const outcome = response['outcome'];
        const dataResponse = response['data'];
        if (outcome.success === true) {
          this.logger.log("Service:", "SUCCESS", 200);
          return response;
        } else {
          this.logger.log("Service:", "FAILURE", 200);
          outcome.message = this.settings.manageErrorMsg(outcome);
          return outcome;
        }
      }
    ), catchError((errorResponse: HttpErrorResponse) => {
        this.logger.log("Error Response:", errorResponse, 200);
        let res: any = errorResponse.error;
        if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
          this.settings.sessionExpired();
        }
        return throwError(() => errorResponse.error);
      }
    ));
  }

  // modify of an element
  deleteElement(path, elementRequest): any {
    path = environment.restBaseUrl + path;
    return this.http
      .put<any[]>(path, elementRequest, this.getRequestOptionArgs())
      .pipe(map(
      (response: HttpResponse<any>) => {
        const outcome = response['outcome'];
        const dataResponse = response['data'];
        if (outcome.success === true) {
          this.logger.log("Service:", "SUCCESS", 200);
          return response;
        } else {
          this.logger.log("Service:", "FAILURE", 200);
          outcome.message = this.settings.manageErrorMsg(outcome);
          return outcome;
        }
      }
    ), catchError((errorResponse: HttpErrorResponse) => {
        this.logger.log("Error Response:", errorResponse, 200);
        let res: any = errorResponse.error;
        if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
          this.settings.sessionExpired();
        }
        return throwError(() => errorResponse.error);
      }
    ));
  }

  invite(idUser: number): any {
    const path = environment.restBaseUrl + '/admin/user/invite/' + idUser;
    const elementRequest: any = {};

    // TODO: inserire la chiamata al servizio corretto!
    return this.http
      .put<any[]>(path, elementRequest, this.getRequestOptionArgs())
      .pipe(map(
      (response: HttpResponse<any>) => {
        const outcome = response['outcome'];
        const dataResponse = response['data'];
        if (outcome.success === true) {
          this.logger.log("Service:", "SUCCESS", 200);
          return response;
        } else {
          this.logger.log("Service:", "FAILURE", 200);
          outcome.message = this.settings.manageErrorMsg(outcome);
          return response;
        }
      }
    ), catchError((errorResponse: HttpErrorResponse) => {
        this.logger.log("Error Response:", errorResponse, 200);
        let res: any = errorResponse.error;
        if (res?.outcome?.code === "0005" || res?.outcome?.code === "0007") {
          this.settings.sessionExpired();
        }
        return throwError(() => errorResponse.error);
      }
    ));
  }

  getRequestOptionArgs(): any {
    //console.log("getRequestOptions");
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth-Token': localStorage.getItem("token") != null ? localStorage.getItem("token") : ''
      })
    };
    return httpOptions;
  }

  refundServicePay(idTicket: number): Promise<void> {
    return new Promise((res, rej) => {
      this.analysisService.refundTicketServicepay(idTicket).subscribe(refunded => {
        if (refunded) {
          this.ui.showSuccessPopup("swal.refund_servicepay_ok");
          res();
        } else {
          rej();
        }
      }, _ => {
        rej();
      });
    });
  }
}

